/* eslint-disable react-hooks/exhaustive-deps */
import { AxiosResponse } from "axios";
import { Dialog } from "primereact/dialog";
import { Dispatch, FormEvent, SetStateAction, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { APIResponseEntity } from "../interface/api-responce";
import { APICreateIDInvitationLink, APIFetchAvailalbleInvitationCounts } from "../service/api-service";
import { checkValidInputOnKeyDown, removeSpaceOnFirstCharacter } from "../service/shared.service";
import { toastOptObj } from "../utils/constants";
import { IsStringNullEmptyOrUndefined } from "../utils/null-check";
import { NUMBER_ONLY_PATTERN } from "../utils/pattern";

export interface ChecksForInvitationPassesAvailability {
    isInvitationPassesAvailable: boolean;
    message: string;
    totalInvitation: number;
    availalbeInvitation: number;
    usedInvitation: number;
    activeIDEventYear: number;
}

function CopyIDEventLink(
    {
        visible,
        setVisible,
        passStatiSticsCB,
        isActionDisabled
    }: {
        visible: boolean;
        setVisible: Dispatch<SetStateAction<boolean>>;
        passStatiSticsCB: (value: ChecksForInvitationPassesAvailability) => void;
        isActionDisabled?: boolean;
    }
) {

    const [contactNumber, setContactNumber] = useState<string>('');
    const [manualCopyLink, setManualCopyLink] = useState<string>("");
    const manualCopyInputRef = useRef<HTMLInputElement>(null);
    const [passStatiStics, setPassStatiStics] = useState<ChecksForInvitationPassesAvailability>({
        isInvitationPassesAvailable: false,
        message: "",
        totalInvitation: 0,
        availalbeInvitation: 0,
        usedInvitation: 0,
        activeIDEventYear: 0,
    });

    useEffect(() => {
        setContactNumber('');
        setManualCopyLink("");

        const fetchDefaultData = async (): Promise<void> => {
            await fetchAvailalbleInvitationCounts();
        }
        fetchDefaultData();
    }, [visible]);


    const fetchAvailalbleInvitationCounts = async (): Promise<void> => {
        const resp: AxiosResponse = await APIFetchAvailalbleInvitationCounts();

        if (!resp || (resp && (resp.status !== 200 || !resp.data))) { return; }

        const apiRespPayload: APIResponseEntity = resp.data;

        if (apiRespPayload.statusCode !== 200 || !apiRespPayload.data) {
            toast.error(apiRespPayload.message || apiRespPayload.errorMsg, { ...toastOptObj });
            return;
        }

        const statstics: ChecksForInvitationPassesAvailability = apiRespPayload.data;
        setPassStatiStics(statstics);
        passStatiSticsCB(statstics);
    };

    const allowToDisableCopyLink = (): boolean => {

        if (passStatiStics.usedInvitation === passStatiStics.totalInvitation) return true;

        if (IsStringNullEmptyOrUndefined(contactNumber)) return true;

        return false;
    };

    const copyTextToClipboard = async (text: string): Promise<boolean> => {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
                return true;
            }
        } catch (_error) {
            // Fall back to execCommand for browsers like iOS Safari.
        }

        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.setAttribute("readonly", "true");
        textArea.style.position = "fixed";
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);

        textArea.focus();
        textArea.select();
        textArea.setSelectionRange(0, textArea.value.length);

        let copied = false;
        try {
            copied = document.execCommand("copy");
        } finally {
            document.body.removeChild(textArea);
        }

        return copied;
    };

    const selectManualCopyLink = (): void => {
        if (!manualCopyInputRef.current) return;

        manualCopyInputRef.current.focus();
        manualCopyInputRef.current.select();
        manualCopyInputRef.current.setSelectionRange(0, manualCopyInputRef.current.value.length);
    };

    const copyLink = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault();
        if (isActionDisabled) return;
        if (allowToDisableCopyLink()) return;

        const resp: AxiosResponse = await APICreateIDInvitationLink(contactNumber);

        if (!resp || (resp && (resp.status !== 200 || !resp.data))) { return; }

        const apiRespPayload: APIResponseEntity = resp.data;

        if (apiRespPayload.statusCode !== 200 || !apiRespPayload.data) {
            toast.error(apiRespPayload.message || apiRespPayload.errorMsg, { ...toastOptObj });
            return;
        }

        const data: { linkToCopy: string; } = apiRespPayload.data;
        const isCopied = await copyTextToClipboard(data.linkToCopy);

        if (!isCopied) {
            setManualCopyLink(data.linkToCopy);
            toast.info("Copy blocked by browser. Tap and hold the link field to copy.", { ...toastOptObj });
            return;
        }

        setManualCopyLink("");
        toast.success("Link copied successfully.", { ...toastOptObj });
        setContactNumber('');

        await fetchAvailalbleInvitationCounts();
    };

    return (
        <>
            <Dialog header={`Copy ID ${new Date().getFullYear()} Invitation Link`}
                visible={visible} style={{ width: '25vw' }}
                onHide={() => { if (!visible) return; setVisible(false); }}>

                <form onSubmit={(e) => copyLink(e)}>
                    <div className="row">
                        <div className="form-group mb-3">
                            <strong>CONTACT NUMBER</strong>
                            <input type="text" name='contactNumber'
                                className="form-control form-control-lg"
                                maxLength={10} value={contactNumber}
                                onChange={(e) => setContactNumber(e.target.value)}
                                disabled={isActionDisabled}
                                onKeyDown={(event: any) => {
                                    checkValidInputOnKeyDown(event, NUMBER_ONLY_PATTERN);
                                    removeSpaceOnFirstCharacter(event);
                                }}
                            />
                        </div>
                    </div>

                    {
                        manualCopyLink && (
                            <div className="row">
                                <div className="form-group mb-3">
                                    <strong>COPY LINK MANUALLY</strong>
                                    <input
                                        ref={manualCopyInputRef}
                                        type="text"
                                        className="form-control form-control-lg"
                                        value={manualCopyLink}
                                        readOnly
                                        onFocus={selectManualCopyLink}
                                        onClick={selectManualCopyLink}
                                    />
                                    <small className="text-muted">Tap and hold to copy this link.</small>
                                </div>
                            </div>
                        )
                    }

                    <div className="row align-items-center">
                        <div className="col-6">
                            <div className="d-flex flex-column">
                                <div className="d-flex">
                                    <h4 className="text-muted">{`${passStatiStics.usedInvitation}/${passStatiStics.totalInvitation}`}</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 text-end">
                            <button type="submit" className="btn btn-block btn-primary"
                                disabled={passStatiStics.usedInvitation === passStatiStics.totalInvitation ? true : allowToDisableCopyLink()||isActionDisabled}
                            >
                                Copy Link
                            </button>
                        </div>
                    </div>
                </form>
            </Dialog>
        </>
    )
}

export default CopyIDEventLink;